import { AnalyticsOrderType } from '../../../constants/analytics';

export const increaseCounter = (text = '') => 20 + (text?.length || 0) * 6 + 12;

export const getSalesByChannelsPieGraphDescription = (currentOrderType) => {
  if (currentOrderType === AnalyticsOrderType.UNITS) return 'Total units';
  if (currentOrderType === AnalyticsOrderType.ORDERS) return 'Total orders';

  return 'Total GMV';
};
